import * as React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Table from "@mui/material/Table";
import { useSelector } from "react-redux";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import { GetInvLotLineDescs } from "../../../services/InvLotLineDesc.handlers";

const TableRowData = [
  "Lot No",
  "PO No",
  "Abarla",
  "Desc.",
  
  "Vendor",
  "Vendor No",
  "Manufacturer",
  "Manufacturer No",
  
  "Status",
  "Action",
];

const InvLotLineDesc = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const authToken = useSelector((state) => state.user.authToken);
  React.useEffect(() => {
    fetchData();
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = () => {
    var options = {
      Authorization: "Bearer " + authToken,
    };
    GetInvLotLineDescs(options).then((response) => {
      if (response.status) {
        setData(response.data);
      }
    });
  };

  return (
    <DashboardLayout>
      <Stack
        spacing={2}
        direction="row"
        style={{ marginBottom: "30px", justifyContent: "end" }}
      >
        <Button
          onClick={() => navigate("/add_InvLotLineDesc")}
          variant="contained"
        >
          <AddIcon /> Add New Lot Line Desc
        </Button>
      </Stack>
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size={"medium"}
        >
          <TableHead>
            <TableRow>
              {/* <TableCell>Abarla</TableCell> */}
              <TableCell>Lot No</TableCell>
              <TableCell>PO No</TableCell>
              <TableCell>Build #</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Assembly Category</TableCell>
              <TableCell>Part</TableCell>
              <TableCell>Part No</TableCell>
              <TableCell>Part Desc.</TableCell>
              

              
              <TableCell>Vendor</TableCell>
              <TableCell>Vendor No</TableCell>
              <TableCell>Manufacturer</TableCell>
              <TableCell>Manufacturer No</TableCell>
              
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow
                    hover
                    // //   onClick={(event) => handleClick(event, row.name)}
                    // role="checkbox"
                    // //   aria-checked={isItemSelected}
                    // tabIndex={-1}
                    key={index}
                    //   selected={isItemSelected}
                  >
                    {/* <TableCell>{item.abarla_Lot_ID}</TableCell> */}
                    <TableCell>{item.lot_No}</TableCell>
                    <TableCell>{item.pO_Number}</TableCell>
                    <TableCell>{item.build_Number}</TableCell>
                    <TableCell>{item.category_Type}</TableCell>
                    <TableCell>{item.assembly_Category_Type}</TableCell>
                    <TableCell>{item.part}</TableCell>
                    <TableCell>{item.part_Number}</TableCell>
                    <TableCell>{item.part_Description}</TableCell>
                    <TableCell>{item.vendor}</TableCell>
                    <TableCell>{item.vendor_No}</TableCell>
                    <TableCell>{item.manufacturer}</TableCell>
                    <TableCell>{item.manufacturer_No}</TableCell>
                   

                    <TableCell>
                      {item.status ? (
                        <span className={"label color-green"}>Active</span>
                      ) : (
                        <span className={"label color-red"}>Blocked</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() =>
                          navigate("/updateInvLotLineDesc/" + item.id)
                        }
                        variant="contained"
                        color="primary"
                      >
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow hover>
                <TableCell colSpan={9} align={"center"}>
                  No Records Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 30, 40]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </DashboardLayout>
  );
};

export default InvLotLineDesc;
